import React from 'react';
import { galleryImages } from '../data/mock';

const Gallery = () => {
  return (
    <div className="min-h-screen vibrant-gradient-bg py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl font-black text-gray-900 mb-4">
            Galéria
          </h1>
          <p className="text-xl text-gray-600">
            Tekintsd meg finom ételeinket és hangulatos büfénket!
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-bold text-lg">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center bg-gradient-to-r from-[#00BCD4] to-[#FFA726] rounded-3xl p-12 text-white">
          <h2 className="text-3xl sm:text-4xl font-black mb-4">
            Éhes lettél? 😋
          </h2>
          <p className="text-xl mb-8">
            Rendeld meg kedvenc ételedet most!
          </p>
          <a
            href="/menu"
            className="inline-block px-8 py-4 bg-white text-[#00BCD4] rounded-xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            Étlap és Rendelés
          </a>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
